<template>
  <div>
    <div class="content-box ys-common-block">
      <div class="img-box">
        <p class="img-bg">
          <span class="ys-common-block-second">
            <img src="@/assets/images/icon_regesiter.png" alt="">
          </span>
        </p>
        <div class="serchBox">
          用户名 &nbsp;&nbsp;&nbsp;&nbsp;
          <Input v-model="UserId" placeholder="请输入用户登录ID" style="width: 200px" />&nbsp;&nbsp;&nbsp;&nbsp;
          <Button class="ys-confirm" shape="circle" icon="ios-search" @click="serchUser">搜索</Button>
        </div>
        <div class="userInfoBox">
          <div class="userInfo" v-if="Object.keys(UserInfo).length>0">
            <div class="sInfo">
              <span>用户名：</span>
              <span>{{UserInfo.user_id}}</span>
            </div>
            <div class="sInfo">
              <span>用户姓名：</span>
              <span>{{UserInfo.user_cn_name}}</span>
            </div>
            <div class="sInfo">
              <span>电话号码：</span>
              <span>{{UserInfo.phone_no}}</span>
            </div>
            <div class="sInfo">
              <span>密码到期日：</span>
              <span>{{UserInfo.pwdexp_bk_date}}</span>
            </div>
            <div class="sInfo">
              <span>用户类型：</span>
              <span>{{UserInfo.user_type==1?"内部":"外部"}}</span>
            </div>
            <div class="sInfo">
              <span>所属部门：</span>
              <span>{{UserInfo.dept_cn_name}}</span>
            </div>
            <div class="sInfo">
              <span>部门角色：</span>
              <span>{{UserInfo.dprl_list[0].bk_expl}}</span>
            </div>
            <div class="sInfo">
              <span>兼职部门：</span>
              <span>-</span>
            </div>
            <div class="sInfo">
              <span>邮箱：</span>
              <span>{{UserInfo.email_add}}</span>
            </div>
          </div>
          <div v-if="UserInfo==null" class="tishi">
            <span>暂无此用户</span>
          </div>
        </div>
        <div class="btn-box" v-if="Object.keys(UserInfo).length>0">
          <Button class="ys-cancel" @click="handleReset" style="width: 200px; margin-right: 20px">取消</Button>
          <Button class="ys-confirm" type="primary" @click="handleSubmit" style="width: 200px;">确认</Button>
        </div>
      </div>
    </div>
    <!-- 二次确认框 -->
    <Alter ref="AlterModal" :configData="AlterConfigData" @change_ok="resetPwd">
    </Alter>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex"
  import {
    mapGetters
  } from "vuex"
  import {
    userLoginOut
  } from "@/utils/sys_utils/sysAction";
  export default {
    data() {
      return {
        UserId: "",
        UserInfo: {},
        AlterConfigData: {}, //二次弹框配置数据
      }
    },
    computed: {
      ...mapGetters(["getCommData"])
    },
    methods: {
      ...mapActions(["queryUserByUserIdAction", "ResetPwdAction"]),
      handleSubmit() {
        this.AlterConfigData = {
          type: "warning",
          title: "警告",
          content: "是否确认重置此用户密码？"
        }
        this.$refs.AlterModal.OpenModal();
      },
      resetPwd() {
        this.ResetPwdAction({
          user_id: this.UserId
        }).then(res => {
          if (res.request_state) {
            this.$Message.success("重置密码成功！");
            //当前登录人信息
            const NowUserInfo = JSON.parse(this.getCommData);
            // 如果修改的是当前的登录人的密码  需要重新登录
            if (NowUserInfo.org_user_id == this.UserId) {
              userLoginOut();
            }
            this.UserInfo = {};
          }
        }).catch(err => {
          this.$Message.error(err);
        })
      },
      handleReset() {
        this.UserInfo = {};
        this.UserId = ""
      },
      serchUser() {
        if (this.UserId != "") {
          this.queryUserByUserIdAction({
            user_id: this.UserId
          }).then(res => {
            if (res) {
              let {
                user_bean,
                request_state
              } = res;
              if (request_state) {
                this.UserInfo = user_bean;
              }
            } else {
              this.UserInfo = null;
            }

          }).catch(err => {
            this.$Message.error(err);
          })
        } else {
          this.$Message.error("请输入用户登录名！")
        }

      }
    }
  }
</script>
<style lang="less" scoped>
  .content-box {
    width: 1320px;
    height: 684px;
    border-radius: 9px;
    display: flex;
    justify-content: center;
    align-items: center;

    .img-box {
      width: 550px;
      text-align: center;

      .btn-box {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: nowrap;
      }

      .img-bg {
        width: 100%;
        height: 132px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;

        &>span {
          height: 100%;
          width: 132px;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 57px;
            height: 78px;

          }
        }
      }

      .userInfoBox {
        width: 100%;
        padding-bottom: 20px;
        margin-bottom: 10px;

        &>div {
          min-height: 100px;
          width: 100%;
        }

        .tishi {
          color: white;
          font-size: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .userInfo {
          display: flex;
          flex-wrap: wrap;
          padding-left: 10px;
          border: 1px solid rgb(221, 221, 221);

          .sInfo {
            height: 45px;
            width: 50%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 16px;
            color: white;

            &>span:nth-child(1) {
              font-weight: 800;
            }

            &>span:nth-child(2) {
              font-weight: 400;
            }
          }

        }
      }

      .serchBox {
        height: 50px;
        margin-bottom: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 16px;
      }
    }
  }
</style>